import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

function CardsImportSummaryDialog({ open, importResult, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Import Summary</DialogTitle>
      <DialogContent>
        {importResult ? (
          <div>
            <div>
              Import completed: {importResult.created_count || 0} created,{" "}
              {importResult.updated_count || 0} updated.
            </div>
            {importResult.ignored_columns && importResult.ignored_columns.length > 0 ? (
              <div style={{ marginTop: 8 }}>
                Ignored columns: {importResult.ignored_columns.join(", ")}
              </div>
            ) : null}
            {importResult.errors && importResult.errors.length > 0 ? (
              <div style={{ marginTop: 12 }}>
                <div>Errors:</div>
                <ul>
                  {importResult.errors.map((e, idx) => (
                    <li key={idx}>
                      Row {e.row} - {e.reason}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CardsImportSummaryDialog;
